import React, { useEffect, useState } from 'react';
import i18next from "i18next";
import { Helmet } from "react-helmet";
import Cookies from 'universal-cookie';

const languageMap = {
    en: { label: "English", dir: "ltr", active: true },
    ar: { label: "العربية", dir: "rtl", active: false },
};

const LanguageSelect = (props) => {
    const cookies = new Cookies();
    const selected = cookies.get('lng') || "en";
    const [isLang, setIsLang] = useState(selected);

    useEffect(() => {
        document.body.classList.remove('en', 'ar');
        document.body.classList.add(isLang);
        document.body.dir = languageMap[isLang].dir;
    }, [isLang])

    const LanguagePicker = (checkbox) => {
        if (checkbox.checked) {
            var defaultLang = 'ar';
        } else {
            var defaultLang = 'en';
        }
        LanguageSelect(defaultLang);
    }

    const LanguageSelect = (item) => {
        i18next.changeLanguage(item);
        cookies.set('lng', item);
        setIsLang(item);
    }

    return (
        <>
            <Helmet>
                {isLang == 'en' && <html lang={isLang} className="ltr" />}
                {isLang == 'ar' && <html lang={isLang} className="rtl" />}
            </Helmet>

            {(props.type === 'A' && isLang == 'en') && <a className="nav-link pointer text-dark-green" onClick={() => LanguageSelect('ar')}>العربية</a>}
            {(props.type === 'A' && isLang == 'ar') && <a className="nav-link pointer text-dark-green" onClick={() => LanguageSelect('en')}>English</a>}

            {props.type === 'B' &&
                <div className="lang-switch shadow">
                    <input id="lang-toggle" className="check-toggle check-toggle-round-flat" type="checkbox" defaultChecked={isLang === 'ar' ? true : false} onChange={(e) => LanguagePicker(e.target)} />
                    <label htmlFor="lang-toggle"></label>
                    <span className="on">EN</span>
                    <span className="off">AR</span>
                </div>
            }
        </>
    )
}

export default LanguageSelect;
